<template>
  <b-sidebar
    id="sidebar-1"
    no-header
    bg-variant="white"
    :width="sidebarWidth"
  >
    <template
      #footer="{ }"
    >
      <div class="d-flex px-3 py-2">
        <div
          style="width: 1.25rem;cursor: pointer;"
          class="mr-1 d-inline-block ml-auto footer-image"
          @click="hideSideBar"
        >
          <template v-if="!sideBarHidden">
            <b-icon-chevron-double-left variant="primary" />
          </template>
          <template v-else>
            <b-icon-chevron-double-right variant="primary" />
          </template>
        </div>
      </div>
    </template>
    <nav class="sidebar-down">
      <b-nav vertical>
        <template v-for="(menu) in menus">
          <!-- eslint-disable-->
          <b-nav-item
            :key="menu.menu_name"
            :id="menu.menu_name"
            :class="[{ menuactive: menu.focus }]"
            @click.exact="menuactive(menu.menu_name);menu.submenuShow=!menu.submenuShow;"

          >
          <b-popover v-if="sideBarHidden" :target="menu.menu_name" triggers="hover focus" placement="rightbottom" custom-class="sidebar-popover">
            <template #title>{{ menu.menu_name }}</template>
             <b-nav-item
              v-for="(child) in menu.children"
              :key="child.submenu_name"
              :to="'/service?category='+child.category"
              class="sidebar-submenu"
              @click.exact="submenuActive(menu.menu_name,child.submenu_name);$root.$emit('bv::hide::popover');setServiceParams(child.submenu_name, child.category);"
            >
              {{ child.submenu_name }}
            </b-nav-item>
          </b-popover>
            <div
              style="width:1.5rem; margin-left:0.125rem;"
              class="mr-3 mb-2 d-inline-block"
            >
              <b-img
                src="@/assets/apps_icon.png"
                class=" w-100"
              />
            </div>
            <div
              v-if="!sideBarHidden"
              class="d-inline-block align-middle"
            >
              {{ menu.menu_name }}
            </div>
            <i
              v-if="menu.children"
              class="arrow-down"
              :class="menu.submenuShow?'up':'down'"
            />
          </b-nav-item>
          <div
            v-if="menu.submenuShow && !sideBarHidden"
            :key="menu.menu_name+menu.menu_name"
            class="animated--slide-out"
          >
            <b-nav-item
              v-for="(child) in menu.children"
              :key="child.submenu_name"
              class="sidebar-submenu"
              :to="'/service?category='+child.category"
              :class="[{ menuactive: child.focus }]"
              @click.exact="submenuActive(menu.menu_name,child.submenu_name);setServiceParams(child.submenu_name, child.category);"
            >
              {{ child.submenu_name }}
            </b-nav-item>
          </div>
        </template>
      </b-nav>
    </nav>
  </b-sidebar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import eventBus from '../../utils/eventbus';

export default {
  data() {
    return {
      sideBarHidden: false,
      sidebarWidth: '18.75rem',
      menus: [{
        menu_name: 'Apps',
        focus: false,
        submenuShow: true,
        children: [{
          submenu_id: '1',
          submenu_name: 'User & Usage Index - B2C',
          category: 'B2C',
          focus: false,
        },
        {
          submenu_id: '2',
          submenu_name: 'User & Usage Index - B2B',
          category: 'B2B',
          focus: false,
        }],
      }],
      isFirstExecution: true,
    };
  },
  computed: {
    ...mapGetters('user', {
      isFocusOnSidebar: 'isFocusOnSidebar',
    }),
    isServiceRoute() {
      return this.$route.name === 'Service';
    },

  },
  watch: {
    isFocusOnSidebar: 'menuInactive',
    isServiceRoute(flag) {
      if (flag) {
        this.isFirstExecution = true;
      }
    },
  },
  created() {
    if (this.$route.name === 'Service') {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      const categoryValue = params.get('category');
      const index = categoryValue === 'B2C' ? 0 : 1;
      const defaultSubmenuName = this.menus[0].children[index].submenu_name;
      const defaultCategory = this.menus[0].children[index].category;
      this.submenuActive('Apps', defaultSubmenuName);
      // eslint-disable-next-line max-len
      this.setServiceParams(defaultSubmenuName, defaultCategory);
    }
  },
  methods: {
    ...mapActions('user', {
      setFocusOnSidebar: 'setFocusOnSidebar',
    }),
    hideSideBar() {
      if (this.sideBarHidden) {
        this.sideBarHidden = false;
        this.sidebarWidth = '15.93rem';
        this.$root.$emit('bv::disable::tooltip');
      } else {
        this.sideBarHidden = true;
        this.sidebarWidth = '3.75rem';
        this.$root.$emit('bv::enable::tooltip');
      }
    },
    menuactive(menuid) {
      this.setFocusOnSidebar(true);
      Object.keys(this.menus).forEach(menu => {
        if (this.menus[menu].menu_name === menuid) {
          this.menus[menu].focus = true;
        } else {
          this.menus[menu].focus = false;
        }
      });
    },
    menuInactive() {
      if (!this.isFocusOnSidebar) {
        this.menuactive('dashboard');
        Object.keys(this.menus).forEach(idx => {
          const menuobj = this.menus[idx];
          menuobj.focus = false;
          Object.keys(menuobj.children).forEach(childidx => {
            menuobj.children[childidx].focus = false;
          });
        });
      }
    },
    submenuActive(menuname, childname) {
      this.menuactive(menuname);
      Object.keys(this.menus).forEach(idx => {
        const menuobj = this.menus[idx];
        menuobj.focus = false;
        Object.keys(menuobj.children).forEach(childidx => {
          menuobj.children[childidx].focus = false;
        });
      });
      Object.keys(this.menus).forEach(idx => {
        if (this.menus[idx].menu_name === menuname) {
          const menuobj = this.menus[idx];
          Object.keys(menuobj.children).forEach(childidx => {
            if (menuobj.children[childidx].submenu_name === childname) {
              menuobj.children[childidx].focus = true;
            }
          });
        }
      });
    },
    freshSubmenuactive(submenuid) {
      Object.keys(this.menus).forEach(idx => {
        const menu = this.menus[idx];
        Object.keys(menu.children).forEach(childidx => {
          if (menu.children[childidx].submenu_id === submenuid) {
            menu.children[childidx].focus = true;
          } else {
            menu.children[childidx].focus = false;
          }
        });
      });
    },
    async setServiceParams(submenuName, category) {
      const interval = await setInterval(() => {
        const eventList = eventBus._events.ServiceDetailsChanged;
        if (eventList === undefined || eventList === null) {
          return;
        }
        // eslint-disable-next-line max-len
        eventBus.$emit('ServiceDetailsChanged', submenuName, category, this.isFirstExecution);
        this.isFirstExecution = false;
        clearInterval(interval);
      }, 100);
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.b-sidebar-outer {
 position: relative !important;
 height: 100% !important;
}
.b-sidebar{
  position: relative !important;
  top: 0.25rem !important;
  height: inherit !important;
  display: block !important;
  font-weight: 700;
  font-size: 1rem;
  .nav-link {
    &:hover {
      background: #E7EFFF;
      color: #2684FF !important;
    }

  }
  .menuactive {
    background: #E7EFFF;
    color: #2684FF !important;
  }
}

.b-sidebar-body{
  overflow: hidden !important;
  height: 80% !important;
}

.b-sidebar-footer {
  position: fixed !important;
  bottom: 0.6rem !important;
  width: 100% !important;
}
.footer-image{
  &:hover {
    background: $gray-500;
  }
}

.sidebar-down{
  .nav-item{
    .nav-link{
      padding-top:0.8125rem;
      padding-bottom:0.8125rem;
    }
    &:hover .arrow-down{
      border: solid #2684FF;
      border-width: 0 0.17rem 0.17rem 0;
      display: inline-block;
      padding: 0.22rem;
    }
  }
}

.arrow-down {
  border: solid #0747A6;
  border-width: 0 0.17rem 0.17rem 0;
  display: inline-block;
  padding: 0.22rem;
}

.down {
  position: absolute;
  right: 7%;
  top: 36%;
  transform: rotate(45deg) translate(0%,-50%);
  -webkit-transform: rotate(45deg) translate(0%,-50%);
}

.up {
  position: absolute;
  right: 7%;
  top: 36%;
  transform: rotate(225deg) translate(0%,50%);
  -webkit-transform: rotate(225deg) translate(0%,50%);
}

.sidebar-down ul li{
  position: relative;
}

.sidebar-submenu{
  .nav-link{
    font-weight: 600;
    font-size: 0.875rem;
    padding-left:5rem;
  }
}

.sidebar-popover{
  width: max-content;
  .popover-header{
    font-weight: 700;
    color: #0747A6;
  }

  .popover-body li{
    list-style-type: none;
  }

  .sidebar-submenu{
    .nav-link{
      padding-left:1rem;
    }
  }
}

// Slide Out Animation

@keyframes slideOut {
  0% {
    transform: translateY(-1rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.animated--slide-out {
  animation-name: slideOut;
  animation-duration: 300ms;
  animation-fill-mode: both;
  animation-timing-function: ease;
}
</style>
